import { Link } from "react-router-dom";
import { MessageCircle, Phone, ClipboardList } from "lucide-react";
import { waLink, PHONE_TEL, track } from "@/lib/site";

export default function FloatingWidgets() {
  return (
    <>
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="Chat with Orvella Overseas on WhatsApp"
        onClick={() => track("whatsapp_click")}
        className="fixed bottom-20 right-4 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-8px_rgba(37,211,102,0.6)] transition-transform hover:scale-105 md:bottom-6 md:right-6"
      >
        <MessageCircle size={26} fill="currentColor" strokeWidth={0} />
      </a>

      <div
        data-testid="mobile-action-bar"
        className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-3 border-t border-line bg-white/97 backdrop-blur md:hidden"
      >
        <a
          href={PHONE_TEL}
          data-testid="mobile-bar-call"
          onClick={() => track("phone_click")}
          className="flex flex-col items-center gap-1 py-2.5 text-[11px] font-bold uppercase tracking-wider text-navy"
        >
          <Phone size={18} className="text-gold-dark" /> Call
        </a>
        <a
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-bar-whatsapp"
          onClick={() => track("whatsapp_click")}
          className="flex flex-col items-center gap-1 border-x border-line py-2.5 text-[11px] font-bold uppercase tracking-wider text-navy"
        >
          <MessageCircle size={18} className="text-gold-dark" /> WhatsApp
        </a>
        <Link
          to="/quote"
          data-testid="mobile-bar-quote"
          onClick={() => track("quote_open")}
          className="flex flex-col items-center gap-1 bg-navy py-2.5 text-[11px] font-bold uppercase tracking-wider text-ivory"
        >
          <ClipboardList size={18} className="text-gold-soft" /> Quote
        </Link>
      </div>
    </>
  );
}
